/**
 * 🔴 **PAPER IS LIGHT** (hardening). In dark mode the call sheet printed near-white ink on white paper
 * and the breakdown sheets as solid dark pages: every colour is a `--v-theme-*` token, and nothing
 * turned the theme back for the printer. For the length of a print the shell's Vuetify theme is light
 * — the tokens every module paints with — and afterwards it is put back. Nothing is persisted: the
 * visitor's choice (the global state's `darkMode`) is never touched, so a print never flips the Desk.
 * The module mirrors the same two events for its own `data-theme` (modules/productions/src/App.vue).
 */
export interface PrintableTheme {
  isDark(): boolean;
  change(name: "light" | "dark"): void;
}

export function installPrintTheme(theme: PrintableTheme, target: Window = window): () => void {
  let restore = false;
  const before = (): void => {
    restore = theme.isDark();
    if (restore) theme.change("light");
  };
  const after = (): void => {
    if (restore) theme.change("dark");
    restore = false;
  };
  target.addEventListener("beforeprint", before);
  target.addEventListener("afterprint", after);
  return () => {
    target.removeEventListener("beforeprint", before);
    target.removeEventListener("afterprint", after);
  };
}
